<template>
  <div class="nuttrema-list-item-custom" v-if="group.items.length > 0">
    <div class="nuttrema-list-item__group">
      <span>{{ group.title }}</span>
    </div>
    <div class="nuttrema-list-item__table">
      <nuttrema-table>
        <template slot="header">
          <nuttrema-table-column :style-props="columns.iconica.style" theme="header"></nuttrema-table-column>
          <nuttrema-table-column :style-props="columns.name.style" :label="columns.name.label" theme="header" ></nuttrema-table-column>
          <nuttrema-table-column :style-props="columns.created.style" :label="columns.created.label" theme="header" ></nuttrema-table-column>
          <nuttrema-table-column :style-props="columns.owner.style" :label="columns.owner.label" theme="header"></nuttrema-table-column>
          <nuttrema-table-column :style-props="columns.lastActivePlan.style" :label="columns.lastActivePlan.label" theme="header"></nuttrema-table-column>
          <nuttrema-table-column :style-props="columns.status.style" :label="columns.status.label" theme="header"></nuttrema-table-column>
          <nuttrema-table-column :style-props="columns.operations.style" theme="header"></nuttrema-table-column>
        </template>
        <template slot="body">
          <div class="nuttrema-table__body__row" v-for="item in group.items" :id="`nuttrema-table-row-${item.id}`">

            <nuttrema-table-column :style-props="columns.iconica.style">
              <el-tooltip class="item" effect="dark" :content="$t('label.last_active_plan_type', { type: _get(item, 'LastActivePlan.SubscriptionPlanType.name', $t('label.none'))} )" placement="top" :open-delay="1000">
                <nuttrema-iconica-sidebar-link
                   theme="instance"
                   fix-picture-transparency
                  :class="`is-${_get(item, 'LastActivePlan.SubscriptionPlanType.code', 'no-plan')}`"
                  :text="_get(item, 'LastActivePlan.SubscriptionPlanType.name', 'NO')"
                  :picture="picture(item)">
                </nuttrema-iconica-sidebar-link>
              </el-tooltip>
            </nuttrema-table-column>

            <nuttrema-table-column :style-props="columns.name.style">
              <div class="two-line-text is-link" @click="gotoDetailsPage(item.id)" :title="$t('label.view_detail')">
                <div v-if="item.name" class="two-line-text__title">
                  <span>{{ item.name }}</span>
                </div>
                <div v-if="item.subdomain" class="two-line-text__description">
                  <span>{{ item.subdomain }}</span>
                </div>
              </div>
            </nuttrema-table-column>

            <nuttrema-table-column :style-props="columns.created.style">
              {{ _get(item, 'created_at') | moment('ll') }}
            </nuttrema-table-column>

            <nuttrema-table-column :style-props="columns.owner.style">
              <div class="two-line-text">
                <div v-if="_get(item, 'Owner.full_name')" class="two-line-text__title">
                  <span>
                    {{ _get(item, 'Owner.full_name') }}
                  </span>
                </div>
                <div v-if="_get(item, 'Owner.email') || _get(item, 'Owner.phone')" class="two-line-text__description">
                  <span>
                    <el-tooltip v-if="_get(item, 'Owner.phone')" class="item" effect="dark" :content="_get(item, 'Owner.phone') | phone" placement="bottom" style="margin-right: 0.25em">
                      <el-button size="mini" type="primary" plain circle @click="copyToClipboard(_get(item, 'Owner.phone'))"><i class="far fa-phone"></i></el-button>
                    </el-tooltip>
                    {{ _get(item, 'Owner.email') }}
                  </span>
                </div>
              </div>
            </nuttrema-table-column>

            <nuttrema-table-column :style-props="columns.lastActivePlan.style">
              <div class="two-line-text">
                <div v-if="_get(item, 'LastActivePlan.name')" class="two-line-text__title">
                  <span>
                    {{ _get(item, 'LastActivePlan.name') }}
                    <el-tag size="mini" :type="_get(item, 'LastActivePlan.SubscriptionPlanType.code') === 'standard' ? '' : 'warning'">{{ _get(item, 'LastActivePlan.SubscriptionPlanType.name') }}</el-tag>
                  </span>
                </div>
                <div v-if="_get(item, 'LastActivePlan.end_date')" class="two-line-text__description">
                  <span>
                    {{ $t('label.subscription_end') }} {{ _get(item, 'LastActivePlan.end_date') | moment('ll') }}
                  </span>
                </div>
              </div>
            </nuttrema-table-column>

            <nuttrema-table-column :style-props="columns.status.style">
              <nuttrema-status-tag
                 related="instance"
                :available="['draft', 'pending', 'active', 'inactive', 'blocked', 'archived']"
                :status="item.status">
              </nuttrema-status-tag>
            </nuttrema-table-column>

            <nuttrema-table-column :style-props="columns.operations.style">
              <router-link
                class="el-button el-button--text"
                :to="{ name: _get(meta, 'navigation.edit'), params: { id: item.id }, query: { returnTo }}">
                {{ $t('label.view_detail') }} <i class="el-icon-arrow-right" aria-hidden="true"></i>
              </router-link>
            </nuttrema-table-column>

          </div>
        </template>
      </nuttrema-table>
    </div>
  </div>
</template>

<script>
import { formatNumber } from 'libphonenumber-js';
import NuttremaIndexListItem from 'components/ui/list/nuttrema-index-list-item';

import NuttremaStatusTag from 'components/ui/label/nuttrema-status-tag';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

export default {
  name: 'sys-admin-instances-list-item',
  mixins: [NuttremaIndexListItem],
  components: {
    NuttremaStatusTag,
    NuttremaIconicaSidebarLink,
  },
  data() {
    return {
      clipboard: null,
      columns: {
        iconica: {
          label: null,
          style: {
            width: '50px',
            'justify-content': 'center',
          },
        },
        name: {
          label: 'label.name',
          style: {
            'min-width': '150px',
            'flex-basis': 'auto',
            'flex-grow': '1',
          },
        },
        created: {
          label: 'label.created',
          style: {
            'max-width': '100px',
            'flex-basis': 'auto',
            'flex-grow': '1',
          },
        },
        owner: {
          label: 'label.instance_owner',
          style: {
            'min-width': '150px',
            'flex-basis': 'auto',
            'flex-grow': '1',
          },
        },
        lastActivePlan: {
          label: 'label.last_active_plan',
          style: {
            'min-width': '150px',
            'flex-basis': 'auto',
            'flex-grow': '1',
          },
        },
        status: {
          label: 'label.status',
          style: {
            'max-width': '125px',
            'min-width': '75px',
            'flex-basis': 'auto',
            'flex-grow': '1',
          },
        },
        operations: {
          label: null,
          style: {
            'min-width': '100px',
            'justify-content': 'flex-end',
          },
        },
      },
    };
  },
  methods: {
    picture(item) {
      return item.Logo ? `${process.env.IMAGES_ROOT}${item.Logo.path}${item.Logo.thumbnails.large.filename}` : null;
    },
    formatPhone(value) {
      return value ? formatNumber(value, 'International') : '';
    },
    copyToClipboard(phone) {
      const text = this.formatPhone(phone);
      this.$copyText(text).then(() => {
        this.$message({
          message: this.$t('label.was_copied_to_clipboard', { text }),
        });
      }, (e) => {
        console.error(e);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/system-administration/instances/list/cmpt-sys-admin-instances-index-list-item.vue